import { Layers, Package, Palette, Wand2, Users } from "@digital-twins/design-system/icons";
import type { IconComponent } from "@digital-twins/design-system/icons";
import type { CreativeEditorKind } from "@/types/creative-library";

export const CREATIVE_LIBRARY_ICONS: Record<CreativeEditorKind, IconComponent> = {
  products: Package,
  subjects: Users,
  brands: Palette,
  boards: Layers,
  creatives: Wand2,
};
